"use client";
import { useEffect } from "react";
import { NhostSessionProvider, useUserId } from "@/lib/nhost/react";

/** Identify the user in Clarity as early as possible so auth redirect sessions get linked. */
const ClarityIdentify = () => {
  const userId = useUserId();
  useEffect(() => {
    if (userId && window.clarity && typeof window.clarity === "function") {
      window.clarity("identify", userId.replace(/-/g, ""));
    }
  }, [userId]);
  return null;
};

export const LayoutContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen mb-24">
      <NhostSessionProvider>
        <ClarityIdentify />
        {children}
      </NhostSessionProvider>
    </div>
  );
};
